<template lang="pug">
  #CustomerTagModel.CustomerModel.CustomerModel-tagModel.overflow-hidden(
    :class="{ 'CustomerModel-active': showModel }"
  )
    .content-header.modal_header.rounded-bottom-1rem.pt-0(
      style="height: 50px;"
    )
      .row.align-items-center.h-100
        .col-10
          h5.mb-0 {{ title }}
        .col-2.d-flex.align-items-center.justify-content-center
          i.iconClose(
            @click="closeModel()"
          )
    .p-3.h-100.overflow-hidden(
      style="padding-top: 60px!important;"
    )
      .content
        multiselect(
          v-model="userLabels",
          tag-placeholder="新增顧客喜好",
          placeholder="輸入文字新增顧客喜好",
          selectLabel="點擊新增顧客喜好",
          deselectLabel="點擊移除顧客喜好",
          selectedLabel="已選擇",
          label="tag_name",
          track-by="tag_key",
          group-values="tag",
          group-label="label",
          :options="tagsOption",
          :multiple="true",
          :taggable="true",
          @tag="addLabelHandler",
          noOptions="無顧客喜好"
        )
          template(slot="Label", slot-scope='{ tags }')
          template(slot="noOptions")
            strong 請按 Enter 新增顧客喜好
        small.d-block.w-100.mt-1.text-muted.text-center 直接在上方欄位輸入新顧客喜好後點選新增顧客喜好即可新增顧客喜好

        .row.mt-3.justify-content-center.align-items-center.h-100
          .col-6
            button.btn.btn-block.btn-remind.font-weight-bold.btn-custom(
              type="button",
              @click="saveHandler()",
              style="border: 4px solid #000;border-radius: 50px;padding: 0px 15px;box-shadow: 0.2rem 0.2rem 0 #00000033;",
            ) 儲存編輯
</template>

<script>
import { mapState } from 'vuex';
import IconCloseUrl from '@/assets/images/icon/icon_close.png';
import $ from 'jquery';

const _ = require('lodash');

export default {
  name: 'TagModel',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      user: null,
      iconUrl: {
        IconClose: IconCloseUrl
      },
      showModel: false,
      time: +new Date(),
      userLabels: [],
      tagsOptionOrigin: [],
      tagsOption: []
    };
  },
  mounted() {
    this.$EventBus.$on('openTagModel', (user) => {
      this.initHandler(user);
    });
  },
  methods: {
    initHandler(user) {
      console.log('開彈窗！');
      const vm = this;
      vm.tagsOptionOrigin = _.cloneDeep(vm.tags);
      _.forEach(vm.tagsOptionOrigin, (res) => {
        if (res.type === 'ba') {
          res.label = '美容顧問建立';
        } else {
          res.label = '品牌建立';
        }
        vm.tagsOption.push(res);
      });
      vm.userLabels = _.cloneDeep(vm.memberTags);
      vm.$set(vm, 'user', user);
      vm.openModel();
    },
    openModel() {
      this.showModel = true;
    },
    closeModel() {
      const vm = this;
      vm.$emit('closeModelHandler');
      vm.showModel = false;
      $('.icon-back').removeClass('d-none');
    },
    addLabelHandler(tag_name) {
      const vm = this;
      vm.userLabels.push({
        tag_name,
        tag_id: null,
        type: 'new',
        tag_key: vm.time + 1
      });
    },
    saveHandler() {
      const vm = this;

      const store_info = {
        member_uuid: vm.user.member_uuid,
        tags: vm.userLabels
      };
      // 儲存
      vm.$store.dispatch('sa_reservation/storeTagsHandler', store_info)
        .then(() => {
          vm.$emit('closeModelHandler');
          vm.showModel = false;
        });
    }
  },
  beforeDestroy() {
    this.$EventBus.$off('openTagModel');
  },
  computed: {
    ...mapState({
      tags: (state) => state.sa_reservation.tags,
      memberTags: (state) => state.sa_reservation.memberTags
    })
  }
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: "icon";
  src: url("../../assets/fonts/icon.eot?hrpp7d");
  src: url("../../assets/fonts/icon.eot?hrpp7d#iefix") format("embedded-opentype"), url("../../assets/fonts/icon.ttf?hrpp7d") format("truetype"), url("../../assets/fonts/icon.woff?hrpp7d") format("woff"), url("../../assets/fonts/icon.svg?hrpp7d#icon") format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}

i {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icon" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 1.2rem;
  margin-bottom: 4px;
}

.iconClose:before {
  content: "\e908";
}
</style>
